import { render, staticRenderFns } from "./ExchangeRecord.vue?vue&type=template&id=c7c74a0c&scoped=true&"
import script from "./ExchangeRecord.vue?vue&type=script&lang=js&"
export * from "./ExchangeRecord.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeRecord.vue?vue&type=style&index=0&id=c7c74a0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c74a0c",
  null
  
)

export default component.exports